export default {
  id: 232,
  title: 'Target #232 - GAAD',
  url: 'https://cssbattle.dev/play/232',
  colors: ['#FDFFE9', '#01385E', '#81CAFE'],
  solution:
    '<p a><p b><p c><style>p[a],p[c]{background:#01385e}body{background:#fdffe9}p{position:fixed;margin:0}p[a]{top:90;left:180;width:40;height:70;box-shadow:-10px 20px #fdffe9,-30px 20px #01385e}p[b]{top:150;left:190;width:40;height:40;border:20px solid #01385e;border-radius:0 40px 0 0}p[c]{top:150;left:130;width:100;height:100;border-radius:1in;box-shadow:20px -130px 0 -30px #01385e,inset 0 0 0 20px #01385e,inset 0 0 0 40px #81cafe',
}
